import React from "react";

const UserFilter = ({ filterText, handleFilter, handleClear }) => (
  <table className="mb-3">
    <tbody>
      <tr>
        <td>
          <input
            className="form-control"
            type="text"
            placeholder="type to filter ..."
            value={filterText}
            onChange={handleFilter}
          />
        </td>
        <td>
          <button className="large-button grey" onClick={handleClear}>
            CLEAR
          </button>
        </td>
      </tr>
    </tbody>
  </table>
);

export default UserFilter;
